export default __webpack_public_path__ + "static/media/PRA_Right_Object_Bell 1.44b9cb28.wav";